import type {
  ActionData,
  ActionDataEditor,
  EventData,
  EventDataEditor,
  FlowActionData,
  FlowActionDataEditor,
  TargetData,
  TargetDataEditor,
} from './type';
import { listEvents } from './actions.events';
import { getActionDataEditorDefault } from './actions.actions';
import { getAtomType } from '../utils/getAtomType';
import { SCROLL_VIEW_KEY } from '@/app/editor/sidebar/constant';

/**
 * getEventData
 * @param event .
 * @returns .
 */
export const getEventData = (event: EventData): EventDataEditor => {
  const events = listEvents();
  const data = event.data || {};

  for (let i = 0; i < events.length; i++) {
    if (events[i].key == event.key) {
      //fill data from settings
      events[i].settings?.forEach((item) => {
        if (data[item.key] == undefined) {
          data[item.key] = item.value;
        }
      });

      return { ...events[i], data: data };
    }
  }
  return {
    key: event.key,
    name: event.key,
    type: 1,
    data: data,
    description: event.key,
    settings: [],
  };
};

/**
 * merge events frontend to eventdataeditor
 * @param events ..
 * @returns ..
 */
export const mergeEventsToEditor = (events: EventData[]): EventDataEditor[] => {
  const eventsData = [];
  for (let i = 0; i < events.length; i++) {
    const eventData = getEventData(events[i]);
    eventsData.push(eventData);
  }
  return eventsData;
};

/**
 * merge actiondata frontend to actiondataeditor
 * @param actionData ..
 * @param atomLabel ..
 * @returns ..
 */
export const mergeActionToEditor = (actionData: ActionData, atomLabel: string): ActionDataEditor => {
  const actionDataEditorDefault = getActionDataEditorDefault(actionData.key, atomLabel);
  return {
    ...actionData,
    name: actionDataEditorDefault?.name || '',
    description: actionDataEditorDefault?.description || '',
    settings: actionDataEditorDefault?.settings || [],
  };
};

/**
 * merge targetdata frontend to targetdataeditor
 * @param targetData ..
 * @returns ..
 */
export const mergeTargetToEditor = (targetData: TargetData): TargetDataEditor => {
  const $atom = jQuery('#gfFrame').contents().find('body').first().find(targetData.id);
  const atomLabel = $atom.attr('data-label') || '';
  const atomType = getAtomType($atom);
  return {
    ...targetData,
    actions: targetData.actions.map((action) => mergeActionToEditor(action, atomLabel)),
    atomLabel: atomLabel,
    atomType: atomType,
  };
};

/**
 * merge actiondata frontend to actiondataeditor
 * @param flowActionData ..
 * @returns ..
 */
export const mergeFlowActionToEditor = (flowActionData: FlowActionData): FlowActionDataEditor => {
  const output = {
    ...flowActionData,
    events: flowActionData.events.map((event) => getEventData(event)),
    targets: flowActionData.targets.map((target) => mergeTargetToEditor(target)),
  };

  return output;
};

/**
 * get Action Style
 * @param actionData ..
 * @returns data object {data: "opacity: 0;", lg: "opacity: 0;", ...}
 */
export const getActionStyle = (actionData: ActionData, interactionKey = ''): any => {
  const actionStyle = {};
  const keys = ['data', 'lg', 'md', 'sm', 'xs'];
  for (let i = 0; i < keys.length; i++) {
    const actionByKey = Object(actionData)[keys[i]];

    if (actionByKey && Object.keys(actionByKey).length) {
      if (actionByKey.direction) {
        if (actionByKey.direction.includes('in') && SCROLL_VIEW_KEY.includes(interactionKey)) {
          Object(actionStyle)[keys[i]] = 'opacity: 0;';
        }
      }
    }
  }
  return actionStyle;
};

/**
 * getStyleFromActionItems
 */
export const getStyleFromActionItems = (dataActions: FlowActionData[]): string => {
  let styleString = '';
  for (let i = 0; i < dataActions.length; i++) {
    const dataAction: any = dataActions[i]
    for (let j = 0; j < dataAction.targets.length; j++) {
      const target = dataAction.targets[j];
      const targetId = target.id;

      for (let k = 0; k < target.actions.length; k++) {
        const action = target.actions[k];

        if (action.type == 1) {
          const style = getActionStyle(action, dataAction?.events?.[0]?.key);

          if (Object.keys(style).length) {
            if (style.data) {
              styleString += `${targetId}{${style.data}}`;
            }
            if (style.lg) {
              styleString += `
              @media (max-width: 767px){
                ${targetId}{
                  ${style.lg}
                }
              }`;
            }
            if (style.md) {
              styleString += `
              @media (max-width: 1199px) and (min-width: 992px)
                ${targetId}{
                  ${style.md}
                }
              }`;
            }
            if (style.sm) {
              styleString += `
              @media (max-width: 991px) and (min-width: 768px)
                ${targetId}{
                  ${style.sm}
                }
              }`;
            }
            if (style.xs) {
              styleString += `
              @media (max-width: 767px){
                ${targetId}{
                  ${style.xs}
                }
              }
              @media (width: 767.2px){
                ${targetId}{
                  ${style.xs}
                }
              }`;
            }
          }
        }
      }
    }
  }
  return styleString;
};
